import React, { useEffect, useState } from 'react';
import { REVIEW_ACTIONS, getVerdictLabel } from '../../../constants/violationConstants';
import { updateViolationEventReview } from '../../../services/violations';
import { extractErrorMessage } from '../../../utils/apiError';
import { formatInTimezone } from '../../../utils/formatInTimezone';

/**
 * P2-04 / Human Review (ТЗ Part 2, раздел 7).
 *
 * Presence-driven: без ключа review панель не рисуется.
 *
 * Оценка достоверности НЕ меняет lifecycle ACTIVE/RESOLVED, поэтому вердикт
 * живёт отдельной строкой «Проверка», а не вторым бейджем рядом со статусом.
 * ACL фронт не дублирует: кнопки показываем всем, кто открыл событие.
 */
const ReviewPanel = ({ event, timezone }) => {
  const [review, setReview] = useState(event?.review ?? null);
  const [comment, setComment] = useState(event?.review?.comment || '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setReview(event?.review ?? null);
    setComment(event?.review?.comment || '');
  }, [event?.id, event?.review]);

  if (!review) return null;

  const submit = (verdict) => {
    setSaving(true);
    setError('');
    updateViolationEventReview(event.id, { verdict, comment })
      // Источник истины — ответ backend, а не то, что мы отправили (ТЗ 11.4).
      .then((updated) => {
        setReview(updated);
        setComment(updated?.comment || '');
      })
      // Старый вердикт остаётся на экране: optimistic-обновлений без rollback не делаем.
      .catch((requestError) => {
        setError(extractErrorMessage(requestError, 'Не удалось сохранить оценку'));
      })
      .finally(() => setSaving(false));
  };

  return (
    <div className="vio-card">
      <p className="vio-drawer-section-title">Проверка</p>

      <div className="ved-review-current">
        <span className="vio-readonly-label">Оценка</span>
        <span className="vio-readonly-value">{getVerdictLabel(review.verdict)}</span>
        {review.reviewer && <span className="vio-field-hint">{review.reviewer}</span>}
        {review.reviewed_at && (
          <span className="vio-field-hint">{formatInTimezone(review.reviewed_at, timezone)}</span>
        )}
      </div>

      <div className="ved-review-actions">
        {REVIEW_ACTIONS.map((action) => (
          <button
            key={action.verdict}
            type="button"
            className={`vio-btn${review.verdict === action.verdict ? ' vio-btn--primary' : ''}`}
            disabled={saving}
            onClick={() => submit(action.verdict)}
          >
            {action.label}
          </button>
        ))}
      </div>

      <div className="vio-field">
        <label className="vio-field-label" htmlFor="ved-review-comment">Комментарий</label>
        <input
          id="ved-review-comment"
          type="text"
          placeholder="необязательно"
          value={comment}
          disabled={saving}
          onChange={(changeEvent) => setComment(changeEvent.target.value)}
        />
      </div>

      {error && <p className="vio-field-error">{error}</p>}
    </div>
  );
};

export default ReviewPanel;
